import { SelectOptionProps } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { ChannelRecordingTaskTypeEnum } from '../types';

export function useChannelRecordingTaskTypeOptions(): SelectOptionProps<ChannelRecordingTaskTypeEnum>[] {
  const { t } = useTranslation();

  return [
    {
      label: t('Manual'),
      value: ChannelRecordingTaskTypeEnum.MANUAL,
    },
    {
      label: t('URL stream'),
      value: ChannelRecordingTaskTypeEnum.URL_STREAM,
    },
    {
      label: t('Fichero'),
      value: ChannelRecordingTaskTypeEnum.FILE,
    },
    {
      label: t('URL fichero'),
      value: ChannelRecordingTaskTypeEnum.URL_FILE,
    },
    {
      label: t('Automática'),
      value: ChannelRecordingTaskTypeEnum.SCHEDULED,
    },
  ];
}
